import { Component, OnDestroy } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { UserActions } from '../actions/user-actions'

@Component({
  selector: 'public-writer-profile-page',
  template: `
    <header-left-nav-layout [showSidebar]="false">
      <div class="container-fluid" main>
        <writer-profile *ngIf="writerSlug" [writerSlug]="writerSlug"></writer-profile>
      </div>
    </header-left-nav-layout>
  `
})
export class PublicWriterProfilePage implements OnDestroy {
  writerSlug: string;
  writerState: string;
  private obs: any;

  constructor(route: ActivatedRoute, userActions: UserActions) {
    userActions.loadUser()
    this.obs = route.params.subscribe(params => {
      this.writerSlug = params["writerSlug"]
    })
  }

  onWriterStateEmission(writerState: string): void {
    this.writerState = writerState
  }

  ngOnDestroy(): void {
    this.obs.unsubscribe()
  }
}
